import { connect } from 'react-redux';
import HealthChecklistContainer from './HealthChecklistContainer';
import {
  CREATE_REMINDER,
  DELETE_REMINDER,
  FETCH_REMINDERS,
  SET_REMINDER_DAY,
  UPDATE_REMINDER,
} from '../../../../../../sagas/reminders';
import { SET_BIRTH_SEX } from '../../../../../../constants/index';
import { remindersReceived } from '../../../../../../ducks/reminders';

const mapStateToProps = (state: any) => ({
  userReminders: state.reminders,
});

const mapDispatchToProps = (dispatch: any) => ({
  fetchReminders: (userProfileId: any) =>
    dispatch({
      type: FETCH_REMINDERS,
      userProfileId,
    }),

  clearReminders: () => dispatch(remindersReceived(null)),

  createReminder: (
    userProfileId: any,
    birthDate: any,
    reminderType: any,
    firstReminderDate: any,
    notify: any,
    status: any
  ) =>
    dispatch({
      type: CREATE_REMINDER,
      userProfileId,
      birthDate,
      reminderType,
      firstReminderDate,
      notify,
      status,
    }),

  setBirthSex: (userProfileId: any, birthSex: any) =>
    dispatch({ type: SET_BIRTH_SEX, userProfileId, birthSex }),

  updateReminder: (reminderId: any, status: any, notify: any) =>
    dispatch({
      type: UPDATE_REMINDER,
      reminderId,
      status,
      notify,
    }),

  deleteReminder: (reminderId: any) =>
    dispatch({
      type: DELETE_REMINDER,
      reminderId,
    }),

  setReminderDay: (userProfileId: any, reminderDay: any) =>
    dispatch({
      type: SET_REMINDER_DAY,
      userProfileId,
      reminderDay,
    }),
});

// @ts-ignore TODO: Fix never type
export default connect(mapStateToProps, mapDispatchToProps)(HealthChecklistContainer);
